const manageContacts = {
    manageContacts: {
        pageTitle: '스케줄 관리',
        pageDescription: '위성 및 교신 스케줄 기록을 조회하고 관리할 수 있습니다.',
        button: {
          search: '검색',
          reset: '초기화'
        }
    }
}

export default manageContacts;